import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ResolverService {

  private httpClient = inject(HttpClient);

  validateHash(linkId: string): Observable<{ url: string }> {
    return this.httpClient.post<{ url: string }>(
      `${environment.hostName}short_links/resolve`,
      { identifier: linkId }
    );
  }
}
